import { render, staticRenderFns } from "./GerenciarUsuarios.vue?vue&type=template&id=1bd8891c&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarUsuarios.vue?vue&type=style&index=0&id=1bd8891c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8891c",
  null
  
)

export default component.exports